<template>
  <div class="course-detail">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/course' }">课程</el-breadcrumb-item>
      <el-breadcrumb-item>课程详情</el-breadcrumb-item>
    </el-breadcrumb>
    <template v-if="videoDetail">
      <div class="video-wrapper">
        <div
          class="title"
        >{{ videoDetail.detail.title }}：{{ currentVideo.title }}</div>
        <div class="sub-title">
          <div>
            {{
            dayjs(videoDetail.detail.setUpdateTime).format('YYYY-MM-DD HH:mm')
            }}
            | 更新至第{{ videoDetail.detail.courseCount }}节 | 已售
            {{ videoDetail.detail.saledCount }} 份
          </div>
          <div v-if="!hasRight(videoDetail.detail.productId)">
            <span class="symbol">￥</span>
            <span class="price">{{ videoDetail.detail.price }}</span>
            <el-button class="button-order" @click="pay">立即购买</el-button>
          </div>
        </div>
        <div class="video-container">
          <div class="video">
            <video-player
              ref="video"
              :play-info="videoPlayInfo"
              video-height="100%"
            ></video-player>
          </div>
          <ul class="video-list">
            <li class="video-list-title">目录</li>
            <li
              v-for="(item, index) in videoList"
              :key="index"
              class="video-item"
              :class="{ 'video-item--active': activeVideoIndex === index }"
              @click="changeVideo(index, item)"
            >
              <span class="icon-video"></span>
              {{ index + 1 }}. {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <EveryBanner class="course-banner" codes="pc_course_detail"></EveryBanner>

      <section class="content">
        <div class="content-left">
          <div class="panel">
            <div class="panel-title">课程介绍</div>
            <div class="description">{{ videoDetail.detail.description }}</div>
          </div>
          <comment-list
            :disabled="!hasRight(videoDetail.detail.productId)"
            :comments-info="videoDetail.commentsInfo"
          ></comment-list>
        </div>
        <div class="content-right">
          <!-- 作者信息 -->
          <author-info-panel :authorInfo="videoDetail.authorInfo"></author-info-panel>

          <!-- 个人介绍 -->
          <personal-description-panel
            :description="videoDetail.detail.description"
          ></personal-description-panel>
          <!-- 热门课程 -->
          <base-panel
            v-if="recommendSetList && recommendSetList.length"
            title="热门课程"
            class="panel-wrapper"
            @toMore="linkToCourse"
          >
            <ul class="hot-course-list">
              <li
                v-for="item in recommendSetList"
                :key="item.setId"
                class="hot-course"
                @click="linkToCourseDetail(item.setId)"
              >
                <div
                  class="head"
                  :style="{ backgroundImage: `url(${item.coverImagUrl})` }"
                ></div>
                <div class="hot-course-right">
                  <div class="name">{{ item.title }}</div>
                  <div class="order-info">
                    <span class="price">¥{{ item.price }}/套</span>
                    <span class="count">{{ item.saledCount }}人购买</span>
                  </div>
                </div>
              </li>
            </ul>
          </base-panel>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { getCourseDetail, getPlayInfo, getRecommendSetList } from '@/api/course'
import dayjs from 'dayjs'
import VideoPlayer from '@/components/VideoPlayer'
import CommentList from '@/components/CommentList/CommentList'
import BasePanel from '@/components/BasePanel/BasePanel'
import PersonalDescriptionPanel from '@/components/PersonalDescriptionPanel/PersonalDescriptionPanel'
import AuthorInfoPanel from '@/components/AuthorInfoPanel/AuthorInfoPanel'
import { mapGetters } from 'vuex'
import EveryBanner from '@/components/EveryBanner'

export default {
  name: 'CourseDetail',
  components: {
    AuthorInfoPanel,
    PersonalDescriptionPanel,
    BasePanel,
    CommentList,
    VideoPlayer,
    EveryBanner
  },
  data() {
    return {
      videoDetail: null,
      activeVideoIndex: 0,
      videoPlayInfo: null,
      recommendSetList: [],
      videoList: []
    }
  },
  computed: {
    setId() {
      return this.$route.params.id
    },
    currentVideo() {
      return this.videoList && this.videoList[this.activeVideoIndex]
    },
    ...mapGetters({
      hasRight: 'right/hasRight'
    })
  },
  created() {
    this.getCourseDetail()
    this.getRecommendSetList()
  },
  beforeRouteUpdate(to, from, next) {
    this.$nextTick(() => {
      this.getCourseDetail()

      window.scrollTo(0, 0)
    })

    next()
  },
  methods: {
    dayjs,
    changeVideo(index, { isFree }) {
      this.activeVideoIndex = index

      if (!isFree && !this.hasRight(this.videoDetail.detail.productId)) {
        this.$message({
          message: '正在播放课程花絮，购买后观看完整视频。',
          type: 'warning'
        })
      }

      this.$nextTick(this.getPlayInfo)
    },
    pay() {
      this.$refs.video.player.pause()
      this.$store.dispatch('cashierDesk/openGoodsAction', {
        setId: this.videoDetail.detail.goodsSetId
      })
    },
    async getCourseDetail() {
      this.videoDetail = await getCourseDetail(this.setId)
      this.videoList = this.videoDetail.courses.page.list
      this.videoList.sort((a, b) => (a.index > b.index ? 1 : -1))
      await this.getPlayInfo(this.currentVideo.videoIdentity)
    },
    async getPlayInfo() {
      if (!this.currentVideo.videoIdentity) return
      this.videoPlayInfo = await getPlayInfo(this.currentVideo.videoIdentity)
    },
    async getRecommendSetList() {
      this.recommendSetList = await getRecommendSetList()
    },
    linkToCourse() {
      this.$router.push('/course')
    },
    linkToCourseDetail(setId) {
      this.$router.push('/course/' + setId)
    }
  }
}
</script>

<style lang="scss" scoped>
.course-banner {
  margin-top: 40px;
}
.course-detail {
  padding-top: 40px;
}

.video-wrapper {
  background-color: #222222;
  color: #ffffff;
  margin-top: 30px;
  padding: 30px 0 30px 20px;

  .title {
    padding-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
    color: #ffffff;
  }

  .sub-title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 20px;
    padding-right: 20px;
    font-size: 14px;
    line-height: 40px;
    color: #858585;

    .symbol {
      font-size: 14px;
      line-height: 1;
      color: #e64c2e;
    }

    .price {
      font-size: 20px;
      font-weight: bold;
      line-height: 1;
      letter-spacing: 1px;
      color: #e64c2e;
    }

    .button-order {
      width: 90px;
      line-height: 40px;
      margin-left: 20px;
      background-color: #e64c2e;
      border-radius: 2px;
      font-size: 16px;
      color: #ffffff;
      padding: 0;
      border: none;
    }
  }
}

.video-list {
  width: 332px;
  height: 480px;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #141414;
  border: solid 1px #262626;
  overflow-y: auto;

  .video-list-title {
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
    color: #fefefe;
    border-bottom: 1px solid #262626;
  }

  .video-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    height: 40px;
    letter-spacing: 1px;
    color: #ffffff;
    cursor: pointer;
  }

  .icon-video {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin: 0 10px;
    background: url('~@/assets/images/course/icon-video1.png') no-repeat center;
    background-size: contain;
  }

  .video-item--active {
    color: #046bcc;
    background-color: #222222;

    .icon-video {
      background-image: url('~@/assets/images/course/icon-video2.png');
    }
  }
}

.video-container {
  display: flex;

  .video {
    width: 820px;
    height: 480px;
    margin-right: 40px;
  }
}

.content {
  display: flex;
}

.content-left {
  flex: auto;
  margin-right: 40px;

  .panel {
    margin: 40px 0;
    padding: 0 20px;
    min-height: 186px;
    border: solid 1px #ebebeb;

    .panel-title {
      display: flex;
      align-items: center;
      height: 60px;
      font-size: 16px;
      font-weight: bold;
      color: #262626;
      border-bottom: solid 1px #ebebeb;
    }
  }

  .description {
    padding: 10px 0;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 1px;
    color: #262626;
  }
}

.content-right {
  width: 332px;
  padding-top: 40px;
}

.panel-wrapper {
  margin-top: 30px;
  margin-bottom: 30px;
  min-height: 220px;
}

.hot-course-list {
  padding-bottom: 20px;
}

.hot-course {
  display: flex;
  margin: 20px 20px 0;
  cursor: pointer;

  .head {
    width: 100px;
    height: 75px;
    background: no-repeat center;
    background-size: contain;
  }

  .hot-course-right {
    padding-left: 15px;
  }

  .name {
    font-size: 16px;
    line-height: 40px;
    color: #262626;
  }

  .order-info {
    display: flex;
    justify-content: space-around;
    padding-top: 10px;

    .price {
      font-size: 14px;
      color: #e64c2e;
    }

    .count {
      font-size: 14px;
      color: #858585;
    }
  }
}
</style>
